/* eslint-disable init-declarations */

export type Branded<T, B>	= T & Branding<T, B>;

export namespace Branded {
	export type Base<T extends Branded<unknown, unknown>>	= T[typeof __BASE__];
	export type Brand<T extends Branded<unknown, unknown>>	= T[typeof __BRAND__];

	/** this is unsafe casting, do not call unless proven to be correct */
	export const brand		= <T extends Branded<unknown, unknown>>(it:Base<T>):T	=> it as T;

	export const unbrand	= <T>(it:Branded<T, unknown>):T	=> it;
}

type Branding<T, B>	= {
	readonly [__BASE__]:	T,
	readonly [__BRAND__]:	B,
};

declare const __BASE__:		unique symbol;
declare const __BRAND__:	unique symbol;
